<template>
  <div class="container bibliography-details my-4">
    <div class="component-header mb-4">
      <h1>Bibliografia</h1>
      <div class="ml-4 add-edit-actions">
        <button @click="save" class="action">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
        <button data-toggle="modal" data-target="#bibliography" class="action">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text"
        v-bind:class="[showMessage ? 'visible' : 'hidden', success ? 'text-success' : 'text-danger']"
      >
        {{ messageText }}
      </div>
    </div>
    <div style="">
      <vue-editor
        v-model="content"
        id="bibliographyContent"
        :editor-toolbar="$settings.editorToolbar"
      />
    </div>
    <Modal v-bind:settings="modalSettings" @confirm="goBack()" />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Modal from "./Modal";
export default {
  components: {
    VueEditor,
    Modal,
  },
  data() {
    return {
      bibliography: {},
      content: "",
      modalSettings: {
        body: "Czy na pewno chcesz wyjść? Niezapisane zmiany zostaną utracone.",
        modalId: "bibliography",
      },
      messageText: "",
      showMessage: false,
      id: null,
      success: false
    };
  },
  methods: {
    initialize: function () {
      this.id = this.$route.params.id;
      if (this.id) {
        this.$api.getBibliographyItem(this.id).then((data) => {
          this.bibliography = data;
          this.content = data.content;
        });
      }
    },
    save: function () {
      let data = { content: this.content, id: this.id };
      if (this.id) {
        this.update(data);
      } else {
        this.create(data);
      }
    },
    update: function (data) {
      this.$api.updateBibliography(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
        } else {
          this.displayFailure();
        }
      });
    },
    create: function (data) {
      this.$api.createBibliography(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
          this.goBack();
        } else {
          this.displayFailure();
        }
      });
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie zapisane";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w zapisie danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    goBack() {
      console.log(this.id);
      this.$router.push({ name: "Bibliography" });
    },
    goBackWithSave() {
      console.log("save");
      this.save();
      this.goBack();
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize();
    next();
  },
};
</script>

<style>
#bibliographyContent {
  height: 800px;
}
.ql-toolbar {
  position: -webkit-sticky;
  position: sticky;
  top: 116px;
  z-index: 100;
  background: white;
}
</style>